export default __webpack_public_path__ + "static/media/122.808513cc.gif";